import React from 'react';
import UiIcon from '../ui/UiIcon';

const GridSidebar = ({
  size,
  onSizeChange,
  onPaste,
  onGenerate,
  disabled,
  isSpecialDate,
  specialTitle,
  specialName,
  onSpecialDateChange,
  onSpecialTitleChange,
  onSpecialNameChange,
  notificationTitle,
  notificationBody,
  onNotificationTitleChange,
  onNotificationBodyChange
}) => {
  const hasSpecialContent = !!(specialTitle || specialName || notificationTitle || notificationBody);

  return (
    <aside className="grid-sidebar">
      <section className="sidebar-section">
        <div className="dimensions-control">
          <input
            type="number"
            min="3"
            max="15"
            value={size.width}
            onChange={(e) => onSizeChange('width', Math.max(3, Math.min(15, parseInt(e.target.value) || 6)))}
            className="dimension-input"
            aria-label="Width"
            disabled={disabled}
          />
          <span aria-hidden="true">×</span>
          <input
            type="number"
            min="3"
            max="15"
            value={size.height}
            onChange={(e) => onSizeChange('height', Math.max(3, Math.min(15, parseInt(e.target.value) || 7)))}
            className="dimension-input"
            aria-label="Height"
            disabled={disabled}
          />
        </div>
        <textarea
          placeholder="Paste grid"
          onChange={(e) => onPaste(e.target.value)}
          className="paste-area"
          aria-label="Paste grid"
        />
        {onGenerate && (
          <button type="button" className="generate-grid-btn" onClick={onGenerate}>
            <UiIcon name="auto_awesome" />
            Generate grid
          </button>
        )}
      </section>

      <section className="sidebar-section">
        <label className="switch-row">
          <span className="switch-title">Special date</span>
          <input
            type="checkbox"
            role="switch"
            className="switch"
            checked={isSpecialDate}
            onChange={(e) => onSpecialDateChange(e.target.checked)}
          />
        </label>

        {!isSpecialDate && hasSpecialContent && (
          <p className="sidebar-warn">Removed on save</p>
        )}

        {isSpecialDate && (
          <div className="special-fields">
            <input
              type="text"
              placeholder="Erikoispäivä"
              aria-label="Occasion"
              value={specialName}
              onChange={(e) => onSpecialNameChange(e.target.value)}
              className="special-input"
            />
            <input
              type="text"
              placeholder="Päivän ristikko"
              aria-label="Puzzle title"
              value={specialTitle}
              onChange={(e) => onSpecialTitleChange(e.target.value)}
              className="special-input"
            />
            <input
              type="text"
              placeholder="Notification title"
              value={notificationTitle}
              onChange={(e) => onNotificationTitleChange(e.target.value)}
              className="special-input special-input-gap"
              maxLength={65}
            />
            <textarea
              placeholder="Notification body"
              value={notificationBody}
              onChange={(e) => onNotificationBodyChange(e.target.value)}
              className="notification-input"
              maxLength={240}
              rows={3}
            />
          </div>
        )}
      </section>
    </aside>
  );
};

export default GridSidebar;
